import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import FaqTabSection from './FaqTabSection';
import { useDispatch, useSelector } from 'react-redux';
import { getFaqSection } from 'redux/actions/UserFAQ';

function FAQ() {
  
  const [value, setValue] = useState('Customer');
  const dispatch = useDispatch();
  const faqSection = useSelector((state) => state?.userFaqSection?.userFaqSection?.data);
  const faqSectionLoader = useSelector((state) => state?.userFaqSection?.loading)
  useEffect(()=>{
    dispatch(getFaqSection()); 
  },[]) 
  const breadcrumbPaths = [
    // { name: 'Configuration', url: '', className:'colorGrey fontSemi' ,},
    { name: 'FAQ', url: '', className:'colorBlue' ,},
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 'Customer') {
      dispatch(getFaqSection())
    }
    else {
      dispatch(getFaqSection())
    }


  };
  return (
  
    <Grid container>
      <CommonBreadCrumb paths={breadcrumbPaths}/>
      <FaqTabSection 
      accordianData={faqSection} 
      handleChange={handleChange} 
      value={value} 
      faqSectionLoader={faqSectionLoader} 
      /> 
    </Grid>
  )
}

export default FAQ;